import config from 'react-global-configuration'
config.set({
    base: "http://zainiraq.livexgames.com/apn",
    subscribe: '/subscribe',
    requestOTP: "/requestOTP",
    activate: "/activate",
    checkSub: "/checkSub",
    login: '/login',
    error : '/error',
    headers: {
        'Reqfrom': 'web',
        'Username': 'web',
        'Language': 'en',
    }
})


export default config